import React, { useState, useEffect, useRef } from 'react';


function HtmlFrame(){
  const src = "./page.html";
    // Danh sách ảnh rơi
    const letterImages = [
      "https://res.cloudinary.com/duk2lo18t/image/upload/v1760871877/the-happy-zone/icon/t2_segwpt.png",
      "https://res.cloudinary.com/duk2lo18t/image/upload/v1760871879/the-happy-zone/icon/h1_xpw7ng.png",
      "https://res.cloudinary.com/duk2lo18t/image/upload/v1760871878/the-happy-zone/icon/h3_pxjb4x.png",
      "https://res.cloudinary.com/duk2lo18t/image/upload/v1760871876/the-happy-zone/icon/q3_mr20ua.png",
      "https://res.cloudinary.com/duk2lo18t/image/upload/v1760871876/the-happy-zone/icon/letters_f8bq5q.png",
      "https://res.cloudinary.com/duk2lo18t/image/upload/v1760871876/the-happy-zone/icon/t5_ogwpqy.png",
    ];
  
    // State
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [centerText, setCenterText] = useState("Mong là bạn cảm thấy vui vẻ mỗi khi ghé thăm trang web nhỏ này!");
    const [hearts, setHearts] = useState([]);
    const [fallingLetters, setFallingLetters] = useState([]);
  
    // Refs
    const audioRef = useRef(null);
    const intervalRef = useRef(null);
  
    // Tạo hiệu ứng trái tim
    const createHeartExplosion = (x, y) => {
      const newHearts = [];
      const heartChars = ['💗'];
      const numHearts = 12;
  
      for (let i = 0; i < numHearts; i++) {
        const angle = (Math.PI * 2 / numHearts) * i;
        const distance = Math.random() * 80 + 40;
  
        newHearts.push({
          id: Date.now() + i,
          x,
          y,
          dx: Math.cos(angle) * distance,
          dy: Math.sin(angle) * distance,
          char: heartChars[Math.floor(Math.random() * heartChars.length)],
          size: Math.random() * 10 + 20
        });
      }
  
      setHearts(prev => [...prev, ...newHearts]);
  
      // Xóa trái tim sau 2 giây
      setTimeout(() => {
        setHearts(prev => prev.filter(heart => !newHearts.includes(heart)));
      }, 2000);
    };
  
    // Tạo chữ rơi
    const createFallingLetter = () => {
      const newLetter = {
        id: Date.now(),
        src: letterImages[Math.floor(Math.random() * letterImages.length)],
        left: Math.random() * (window.innerWidth - 50),
        top: -50
      };
  
      setFallingLetters(prev => [...prev, newLetter]);
  
      // Xóa chữ sau 8 giây
      setTimeout(() => {
        setFallingLetters(prev => prev.filter(letter => letter.id !== newLetter.id));
      }, 8000);
    };
  
    // Xử lý click chữ rơi
    const handleLetterClick = (e, letter) => {
      e.stopPropagation();
      createHeartExplosion(e.clientX, e.clientY);
  
      // Xóa chữ được click
      setFallingLetters(prev => prev.filter(l => l.id !== letter.id));
  
      // Hiển thị popup sau 300ms
      setTimeout(() => {
        setShowPopup(true);
  
      }, 300);
  
    };
    // Effect cho chữ rơi
      useEffect(() => {
        intervalRef.current = setInterval(() => {
          createFallingLetter();
        }, 1000);
    
        return () => {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
          }
        };
      }, []);
    
      // Effect cập nhật vị trí chữ rơi
      useEffect(() => {
        const updateLetters = () => {
          setFallingLetters(prev =>
            prev.map(letter => ({
              ...letter,
              top: letter.top + 2
            }))
          );
        };
    
        const animationInterval = setInterval(updateLetters, 50);
        return () => clearInterval(animationInterval);
      }, []);
  return (
    <>
      {/* Hiển thị trái tim */}
      {hearts.map(heart => (
        <div
          key={heart.id}
          className="heart"
          style={{
            left: heart.x,
            top: heart.y,
            fontSize: `${heart.size}px`,
            '--dx': `${heart.dx}px`,
            '--dy': `${heart.dy}px`
          }}
        >
          {heart.char}
        </div>
      ))}

      {/* Hiển thị chữ rơi */}
      {fallingLetters.map(letter => (
        <img
          key={letter.id}
          src={letter.src}
          className="falling-letter"
          style={{
            left: `${letter.left}px`,
            top: `${letter.top}px`
          }}
          onClick={(e) => handleLetterClick(e, letter)}
          alt="Falling letter"
        />
      ))}
      <iframe
        src={src}
        style={{ width: "100%", height: "100vh", border: "none" }}
      />
    </>

  );
}
export default HtmlFrame;